/** 路由配置 */
import { lazy } from 'react';
import { RouteConfig } from 'k-soup/router';
import WujieReact from 'wujie-react';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import App from '@/App';

// Wujie 子应用配置
const blogUrl = import.meta.env.PROD
  ? 'https://blog.yourdomain.com'
  : 'http://localhost:5274';

const BlogWujieElement = (
  <div className="space-y-3">
    <h2 className="text-xl font-semibold">Blog 子应用（Wujie 集成）</h2>
    <p className="text-sm text-gray-500">
      此区域通过 Wujie 加载 k_blog 子应用。
    </p>
    <WujieReact
      width="100%"
      height="600px"
      name="k_blog"
      url={blogUrl}
      sync
      props={{}}
    />
  </div>
);

export const routes: RouteConfig[] = [
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        component: lazy(() => import('@/pages/home')),
        meta: { title: '首页' },
      },
      {
        path: 'about',
        component: lazy(() => import('@/pages/About')),
        meta: { title: '关于' },
      },
      {
        path: 'write',
        component: lazy(() => import('@/pages/write')),
        meta: { title: '笔顺练习' },
      },
      {
        path: 'rich',
        component: lazy(() => import('@/pages/rich')),
      },
      {
        path: 'ac',
        component: lazy(() => import('@/pages/AC')),
        meta: { title: 'AC' },
      },
      {
        path: 'dashboard',
        component: lazy(() => import('@/pages/dashboard/Layout')),
        meta: { title: '仪表盘' },
        children: [
          {
            path: 'analytics',
            component: lazy(() => import('@/pages/dashboard/Analytics')),
            meta: { title: '数据分析' },
          },
          {
            path: 'reports',
            component: lazy(() => import('@/pages/dashboard/Reports')),
            meta: { title: '报表' },
          },
        ],
      },
      {
        path: 'blog/*',
        element: BlogWujieElement,
        meta: { title: '博客' },
      },
      {
        path: 'read',
        component: lazy(() => import('@/pages/read/BookshelfPage')),
        meta: { title: 'EPUB 书架' },
      },
      {
        path: 'read/book/:bookId',
        component: lazy(() => import('@/pages/read/BookReaderPage')),
        meta: { title: 'EPUB 阅读' },
      },
      {
        path: 'read/notes/:bookId',
        component: lazy(() => import('@/pages/read/MyNotesPage')),
        meta: { title: '我的笔记' },
      },
      {
        path: 'showcase/im-sdk',
        component: lazy(() => import('@/pages/showcase/ImSdk')),
        meta: { title: 'Showcase · IM SDK' },
      },
      {
        path: 'showcase/rpa',
        component: lazy(() => import('@/pages/showcase/ProjectShowcase')),
        meta: { title: 'Showcase · RPA' },
      },
      {
        path: 'showcase/electron',
        component: lazy(() => import('@/pages/showcase/ProjectShowcase')),
        meta: { title: 'Showcase · 桌面工具' },
      },
      {
        path: 'showcase/mini-program',
        component: lazy(() => import('@/pages/showcase/ProjectShowcase')),
        meta: { title: 'Showcase · 微信小程序' },
      },
      {
        path: 'flow',
        component: lazy(() => import('@/pages/flow')),
        meta: { title: '对话流图编辑器' },
      },
      {
        path: 'crx',
        component: lazy(() => import('@/pages/crx')),
        meta: { title: 'CRX 扩展' },
      },
    ],
  },
];
